import {
  MERCHANT_FETCH,
  MERCHANT_FETCH_SUCCESS,
  MERCHANT_FETCH_FAIL,
  CHANGE_SELECT_MERCHANT,
  MERCHANT_SUMMARY_FETCH,
  MERCHANT_SUMMARY_FETCH_SUCCESS,
  MERCHANT_SUMMARY_FETCH_FAIL

} from '../actions';

export const merchantFetch = (merchant, history, desiredPath) => ({
  type: MERCHANT_FETCH,
  payload: { merchant, history, desiredPath }
});

export const merchantSuccess = (merchant) => ({
  type: MERCHANT_FETCH_SUCCESS,
  payload: merchant
});

export const merchantFail = (message) => ({
  type: MERCHANT_FETCH_FAIL,
  payload: { message }
});

export const changeSelectMerchant= (selectMercahntid) => {
    return (
        {
            type: CHANGE_SELECT_MERCHANT,
            payload: selectMercahntid
        }
    )
}

export const merchantSummaryFetch = (merchantSummary) => ({
  type: MERCHANT_SUMMARY_FETCH,
  payload: { merchantSummary }
});

export const merchantSummarySuccess = (merchantSummary) => ({
  type: MERCHANT_SUMMARY_FETCH_SUCCESS,
  payload: { merchantSummary }
});

export const merchantSummaryFail = (message) => ({
  type: MERCHANT_SUMMARY_FETCH_FAIL,
  payload: { message }
});
